module.exports = "/images/bt.svg?40790e7a3d92c6b3ea0150da4b7ad759";